import { isInAppBrowser } from './utilities'

export const resdiary = () => {
	
	let els = document.querySelectorAll('[data-action="toggle-widget"]:not(.resdiary-active), [href="#book"]:not(.resdiary-active)')
	
	// if (isInAppBrowser()) {
	// 	window.location.href = `x-safari-${window.location.href}`
	// }

	if (!els.length) return

	els.forEach(el => {

		el.classList.add('resdiary-active')

		el.addEventListener('click', e => {
			console.log('click')
			if (document.body.getAttribute('data-booking-widget') === 'active') {
				document.body.removeAttribute('data-booking-widget')
			} else {
				document.body.setAttribute('data-booking-widget', 'active')
			}
			e.preventDefault()
		})
	})

	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape' || event.key === 'Esc') {
			document.body.removeAttribute('data-booking-widget')
		}
	})
}

export default () => { }